import React, { useState } from "react";

function LogoImage() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="logo-wrapper"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <img src="https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/logo.png" alt="Logo" className="logo-img" />

      <img
        className={`logo-hover ${isHovered ? "fade-in" : "fade-out"}`}
        src="https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/logo-equinox.png"
        alt="Equinox"
      />
    </div>
  );
}

export default LogoImage;
